// src/pages/Services/Services.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom'; 
import './Services.scss';

// Import images (you'll need to add these to your project)
import dmsImage from '../../assets/images/dms-services.jpg';
import gisImage from '../../assets/images/gis-mapping.jpg';
import economicImage from '../../assets/images/economic-analysis.jpg';
import monitoringImage from '../../assets/images/monitoring-evaluation.jpg';
import itImage from '../../assets/images/it-services.jpg';

const Services = () => {
  const [activeService, setActiveService] = useState('gis');

  const services = {
    gis: {
      title: "GIS Mapping Services",
      description: "SIMAK IT Pvt Ltd. is a technology driven GIS services provider. With our experienced technical staff, we aim at providing high quality and innovative GIS based solutions. We specialize in designing, developing, and deploying GIS solutions for our various clients that maximize information resources across the organization.",
      benefits: [
        "Assets Mapping Of 2D Building to 3D Building",
        "Creation of Basemap with high-resolution Satellite and Drone Imagery",
        "Assets Mapping of Telecom Tower with components of Auto-Cad",
        "Scanning & organization of Cadastral map belongs to Land Record Department"
      ],
      digitalServices: [
        "Data Conversion Services",
        "Land Information Systems",
        "Natural Resources Management Solutions",
        "Urban Planning Applications",
        "Custom GIS Solution Development"
      ],
      image: gisImage
    },
    dms: {
      title: "Document Management System",
      description: "A Document Management System (DMS) is an advanced software solution designed to help organizations securely store, manage, and track electronic documents and images of paper-based information. Our DMS solutions centralize document storage, making it easier to retrieve, edit, and share documents across teams and departments, boosting overall operational efficiency and productivity.",
      benefits: [
        "Secure document storage with encryption and access control",
        "Version control and audit trails for compliance",
        "Real-time collaboration and document sharing",
        "Reduction in physical storage costs and paper usage"
      ],
      digitalServices: [
        "Document classification and records management",
        "Scanning and digitization of various record types",
        "Integration with CRM and ERP systems",
        "Workflow automation for document processes",
        "Compliance with GDPR/HIPAA regulations"
      ],
      image: dmsImage
    },
    it: {
      title: "IT Enabled Services",
      description: "Our IT Consultancy services are designed to guide businesses through the complexities of technology, helping them optimize processes and stay competitive. We offer expert advice on IT strategy, system integration, infrastructure management, and digital transformation to help organizations enhance operational efficiency, reduce costs, and drive innovation.",
      benefits: [
        "Facility Management for hardware and surveillance systems",
        "Data communication equipment management for railways",
        "Custom software development tailored to client needs",
        "Cloud solutions implementation and cybersecurity enhancement"
      ],
      digitalServices: [
        "IT infrastructure consulting",
        "System integration services",
        "Digital transformation strategy",
        "Workflow optimization solutions",
        "Cybersecurity assessments"
      ],
      image: itImage
    },
    economic: {
      title: "E-Governance & Statistical Services",
      description: "We provide comprehensive economic and statistical services involving data collection, analysis, and reporting to support government decision-making. Our services help in policy formulation, budget allocation, and economic growth strategies through accurate statistical data analysis.",
      benefits: [
        "Revenue generation for local bodies through trade license implementation",
        "Market research and economic trend analysis",
        "Door-to-door survey for real-time data collection",
        "Urban planning and social welfare program support"
      ],
      report: {
        headers: [
          "Economic Indicators",
          "Statistical Analysis"
        ],
        data: [
          ["Market Trends", "Employment Data"],
          ["Inflation Analysis", "Growth Projections"]
        ]
      },
      image: economicImage
    },
    training: {
      title: "Training Programs",
      description: "We offer specialized training programs to enhance digital literacy and technical skills. Our courses range from basic computer proficiency to advanced vocational training, designed to equip individuals with industry-relevant skills for direct employment and career advancement.",
      benefits: [
        "ICT training covering digital technologies and cybersecurity",
        "MSCIT certification for fundamental computer skills",
        "Vocational training with hands-on experience",
        "Job-oriented skill development programs"
      ],
      digitalServices: [
        "Information and Communication Technology courses",
        "Maharashtra State Certificate in IT (MSCIT)",
        "Vocational certification programs",
        "Industry-specific technical training",
        "Digital literacy workshops"
      ],
      image: monitoringImage
    }
  };

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <h1>Our Professional Services</h1>
          <p className="subtitle">
            Discover how our comprehensive GIS, DMS, IT, e-governance and training services can transform your organization with technology-driven solutions.
          </p>
        </div>
      </section>

      {/* Services Menu */}
      <section className="services-menu">
        <div className="container">
          <div className="menu-items">
            <button 
              className={`menu-item ${activeService === 'gis' ? 'active' : ''}`}
              onClick={() => setActiveService('gis')}
            >
              GIS Mapping
            </button>
            <button 
              className={`menu-item ${activeService === 'dms' ? 'active' : ''}`}
              onClick={() => setActiveService('dms')}
            >
              Document Management
            </button>
            <button 
              className={`menu-item ${activeService === 'it' ? 'active' : ''}`}
              onClick={() => setActiveService('it')}
            >
              IT Services
            </button>
            <button 
              className={`menu-item ${activeService === 'economic' ? 'active' : ''}`}
              onClick={() => setActiveService('economic')}
            >
              E-Governance
            </button>
            <button 
              className={`menu-item ${activeService === 'training' ? 'active' : ''}`}
              onClick={() => setActiveService('training')}
            >
              Training
            </button>
          </div>
        </div>
      </section>

      {/* Active Service Content */}
      <section className="service-content">
        <div className="container">
          <div className="content-wrapper">
            <div className="text-content">
              <h1>{services[activeService].title}</h1>
              <p className="service-description">
                {services[activeService].description}
              </p>
              
              <div className="key-benefits">
                <h2>Key Services</h2>
                <ul>
                  {services[activeService].benefits.map((benefit, index) => (
                    <li key={index}>{benefit}</li>
                  ))}
                </ul>
              </div>
            </div>
            
            {services[activeService].image && (
              <div className="image-content">
                <img src={services[activeService].image} alt={services[activeService].title} />
              </div>
            )}
          </div>
          <div className="get-started">
            <Link to="/projects" className="btn btn-primary">View Projects</Link>
          </div>

          {/* {activeService === 'economic' && (
            <>
              <div className="divider"></div>
              <div className="report-section">
                <h3>Economic Reporting</h3>
                <table>
                  <thead>
                    <tr>
                      {services.economic.report.headers.map((header, index) => (
                        <th key={index}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {services.economic.report.data.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {row.map((cell, cellIndex) => (
                          <td key={cellIndex}>{cell}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )} */}

          
        </div>
      </section>

      {/* Working Process */}
      <section className="working-process">
        <div className="container">
          <h2>Our Working Process</h2>
          <p className="subtitle">
            We follow a proven methodology to ensure successful project delivery and client satisfaction
          </p>
          
          <div className="process-steps">
            <div className="step">
              <div className="step-number">01</div>
              <h3>Requirement Analysis</h3>
              <p>Understanding your business needs and objectives</p>
            </div>
            <div className="step">
              <div className="step-number">02</div>
              <h3>Solution Design</h3>
              <p>Creating customized technology solutions</p>
            </div>
            <div className="step">
              <div className="step-number">03</div>
              <h3>Implementation</h3>
              <p>Deploying solutions with best practices</p>
            </div>
            <div className="step">
              <div className="step-number">04</div>
              <h3>Support & Training</h3>
              <p>Ensuring smooth adoption and ongoing support</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials">
        <div className="container">
          <h2>What Our Clients Say</h2>
          <p className="subtitle">Don't just take our word for it - hear from satisfied clients</p>
          
          <div className="testimonial-grid">
            <div className="testimonial-card">
              <div className="stars">★★★★★</div>
              <blockquote>
                "Their GIS mapping services transformed our urban planning initiatives with precise 3D modeling and drone imagery."
              </blockquote>
              <div className="client-info">
                {/* <strong>City Development Authority</strong> */}
                <p>Urban Planning Department</p>
              </div>
            </div>
            
            <div className="testimonial-card">
              <div className="stars">★★★★★</div>
              <blockquote>
                "The DMS implementation eliminated our paper processes and improved compliance through excellent version control."
              </blockquote>
              <div className="client-info">
                {/* <strong>Financial Services Company</strong> */}
                <p>Records Management Team</p>
              </div>
            </div>
            
            <div className="testimonial-card">
              <div className="stars">★★★★★</div>
              <blockquote>
                "Their IT consultancy helped us streamline operations and implement cost-effective cloud solutions."
              </blockquote>
              <div className="client-info">
                {/* <strong>Manufacturing Enterprise</strong> */}
                <p>IT Department</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Ready to Transform Your Organization?</h2>
          <p>Let's discuss how our technology solutions can drive efficiency and innovation for your business.</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary">Contact Our Team</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;